/* eslint-disable no-mixed-spaces-and-tabs */
/* global $ */
import stringUtils from "@/commons/utils/string.utils";
import moment from "moment";
import Qs from "qs";
import Vue from "vue";
import webUtils from "@/commons/utils/web.utils";

let SESSION_KEY = "HWSSessions";
let SESSION_DATE = "syncDate";
let TIMEOUT = (1000 * 60) * 180;

export default {

	data() {

		const PASSWORD_REGS = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?^()&])[A-Za-z\d@$!%*#?^()&]{8,20}$/;

		return {
			PASSWORD_REGS
		}
	},

	created() {

		if (this.getSessionProc() !== undefined) {
			this.$session.set(SESSION_DATE, new Date())
		}

	},

	methods: {

		SESSION_KEY() {
			return SESSION_KEY;
		},

		isMine(_writerKey) {
			if (this.isLogin()) {
				const userId = this.$session.get(SESSION_KEY).coEmailId
				if (userId !== undefined && userId === _writerKey) {
					return true;
				}
			}

			return false;
		},


		/**
		 * 로그인 페이지로 이동
		 */
		goLogin() {

			let params = (!this.stringUtils.isEmpty(Qs.stringify(this.$route.query))) ? "?" + Qs.stringify(this.$route.query) : "";
			let pathname = location.pathname;
			let referrer = (this.stringUtils.isEmpty(params)) ? "?referrer=" + encodeURIComponent(pathname) : "?referrer=" + encodeURIComponent(pathname + params);
			location.href = "/member/login" + referrer;
			/*this.$router.push({
				name: "login"
			})*/
		},


		/**
		 * 현재 페이지 로그인 페이지로 대체
		 */
		resetLogin() {

			this.$router.replace({
				name: "login"
			})
		},


		/**
		 * 현재 로그인 세션 조회
		 * @returns {*}
		 */
		getSessionProc() {
			//console.log( this.$session.get(SESSION_KEY) )
			if (this.isLogin()) {
				return this.$session.get(SESSION_KEY);
			}
			return null;
		},


		getLoginId() {
			if (this.isLogin()) {
				return this.$session.get(SESSION_KEY).coEmailId;
			}
			return this.getVueSessionID();
		},


		/**
		 * VUE 세션 ID 조회
		 * @returns {null|*}
		 */
		getVueSessionID() {
			return this.$session.get("session-id");
		},


		/**
		 * 현재 로그인 상태
		 */
		isLogin: function () {
			return (this.$session.get(SESSION_KEY) !== undefined && stringUtils.isEmpty(this.$session.get(SESSION_KEY).coEmailId) !== undefined);
		},


		/**
		 * 로그인 확인 후 로그인 화면 이동
		 * @param $this
		 * @param _isCancel false 일 경우 alert 후 강제 로그인 이동
		 * @returns {Promise<unknown>|boolean}
		 */
		requireLogin($this, _isCancel = true) {
			if (!$this.isLogin()) {

				return new Promise((resolve, reject) => {
					// $this.swalUtils.fire("로그인 후 사용하실 수 있습니다.", "확인 버튼을 누르시면 로그인 페이지로 이동합니다.", "info", null, true)
					$this.swalUtils.fire("로그인 후 사용가능합니다.", "로그인 화면으로 이동합니다.", "info", null, _isCancel)
						.then((result) => {

							let temp = "";
							if (Object.keys($this.$route.query).length > 0) {
								temp = "?" + Qs.stringify($this.$route.query)
							}
							temp = location.pathname + temp

							if (result.isConfirmed) {
								location.href = "/member/login?referrer=" + encodeURIComponent(temp);
							} else {
								if (!_isCancel) {
									location.href = "/member/login?referrer=" + encodeURIComponent(temp);
								}
								return false;
							}
						})
				})
			}

			return true;
		},

		/**
		 * 자바에서 체크할 세션 ID
		 * @returns {*}
		 */
		JSESSIONID() {
			if (this.isLogin()) {
				return this.$session.get(SESSION_KEY).sessionId;
			} else {
				return null;
			}
		},


		/**
		 * 세션키에 데이터 입력
		 * @param _obj
		 */
		setSessionProc(_obj, _opener = null) {

			const self = this
			return new Promise((resolve, reject) => {

				self.$session.destroy()

				let called = "www"

				called = _obj.coCode

				/**
				 * 계정 아이디 or 이름 or 닉네임 이 없으면 가입폼으로 이동
				 */
				if (self.stringUtils.isEmpty(_obj.coEmailId) || self.stringUtils.isEmpty(_obj.userName) || self.stringUtils.isEmpty(_obj.nickName)) {
					const url = location.origin.replace(webUtils.getSubdomainWithURLString(location.href), called ? called : "www") + "/member/joinForm?caidx=" + _obj.caidx
					// if (_obj.snsService === 'apple') {
					// 	if (window.opener) {
					// 		self.$nextTick(() => {
					// 			window.opener.postMessage({ key: "go", to: url }, location.origin.replace(webUtils.getSubdomainWithURLString(location.origin), self.$route.params.subDomain))
					// 			window.opener.focus()
					// 			close()
					// 		})
					// 	} else {
					// 		history.back()
					// 	}
					// }

					if (_opener == null) {
						location.href = url
					} else {
						self.appClose({
							url: url
						})
					}
					/*this.$router.push({
						name: "joinForm",
						params: {
							caidx: _obj.caidx
						},
					})*/
					resolve(false)
					// return false
					return
				}

				/**
				 * 가입인증 안됐을 경우 인증페이지로
				 */
				if (_obj.authEmail === false) {
					const url = location.origin.replace(webUtils.getSubdomainWithURLString(location.href), called ? called : "www") + "/member/joinAuth?caidx=" + _obj.caidx
					// if (_obj.snsService === 'apple') {
					// 	if (window.opener) {
					// 		self.$nextTick(() => {
					// 			window.opener.postMessage({ key: "go", to: url }, location.origin.replace(webUtils.getSubdomainWithURLString(location.origin), self.$route.params.subDomain))
					// 			window.opener.focus()
					// 			close()
					// 		})
					// 	} else {
					// 		history.back()
					// 	}
					// }

					if (_opener == null) {
						location.replace(url)
					} else {
						self.appClose({
							url: url
						})
					}
					/*this.$router.push({
						name: "joinAuth",
						params: {
							caidx: _obj.caidx
						},
					})*/
					resolve(false)
					return
				}

				self.$session.destroy()
				self.$session[SESSION_DATE] = new Date()
				self.$session.set(SESSION_KEY, _obj)
				self.$session.start()

				resolve(true)

			})
		},


		setSessionKeep(_isKeep) {

			const self = this
			if (this.isLogin()) {
				var temp = self.$session.get(SESSION_KEY)
				temp.isKeepSession = _isKeep;
				self.$session.set(SESSION_KEY, temp);
			}
		},


		/**
		 * 실제 로그인 호출
		 * @param _userid
		 * @param _passwd
		 */
		doLoginProc(_userid, _passwd, _callback) {
			const self = this

			this.$session.destroy()
			this.$eventBus.$emit("startProgress", 2)
			this.axiosCaller.post(this, this.APIs.SESSION + "/doLogin", {
				userid: _userid,
				passwd: _passwd,
				deviceToken: document.querySelector('#deviceToken').value,
			}, (res) => {
				this.$eventBus.$emit("doneProgress", 2)
				let result = res.data

				if (result.status === "ok") {

					if (result.coAccountVO.isUse === true) {
						this.setSessionProc(result.coAccountVO)
						.then((ok) => {
							if (ok) {
								if (_callback != null) {
									_callback()
									return
								} else {
									location.reload()
								}
							}
							else return
						})
					} else {
						this.swalUtils.fire("탈퇴된 계정입니다.", "관리자에게 문의바랍니다.", "info", null, null)
					}

				} else {
					this.swalUtils.gritter("회원가입 미완료 계정입니다.", result.msg, "question", 5000)
					//this.swalUtils.gritter("Fail", "일치하는 회원정보가 없습니다.", "question")
					return;
				}
			})

		},

		/**
		 * 로그인 후 처리 함수
		 * 로그인 계정에 맞는 referrer 로 이동
		 * 1. referrer 가 없으면 로그인 coCode 에 맞는 메인 페이지 이동
		 * 2. referrer 가 router 에 없으면 메인 페이지 이동
		 * 3. 이동 후 로그인 세션 추가
		 *
		 * @param _this :: instanceof Vue
		 * @param _callback
		 */
		goWithCoCode(_this, _callback = null) {
			try {
				// IP 주소나 localhost인지 먼저 확인
				const isIPOrLocalhost = location.hostname.match(/^\d+\.\d+\.\d+\.\d+$/) || 
				                        location.hostname === 'localhost' || 
				                        location.hostname === '127.0.0.1';
				
				let subDomain = "www"; // 기본값
				
				// IP 주소나 localhost가 아닌 경우에만 서브도메인 추출
				if (!isIPOrLocalhost) {
					// 도메인 구조 분석: www.ssflex.co.kr 또는 ssflex.co.kr
					const parts = location.hostname.split('.');
					
					// ssflex.co.kr 같은 경우 (3개 파트): 서브도메인 없음, www로 처리
					// www.ssflex.co.kr 같은 경우 (4개 파트 이상): 첫 번째가 서브도메인
					if (parts.length >= 4) {
						// 4개 이상 파트면 첫 번째가 서브도메인
						subDomain = parts[0];
						// 숫자로 시작하는 경우(IP처럼 보이는 경우) 제외
						if (!isNaN(subDomain)) {
							subDomain = "www";
						}
					} else if (parts.length === 3) {
						// 3개 파트면 메인 도메인 (ssflex.co.kr) - www로 처리
						subDomain = "www";
					}
				}
				let coInfoVO = this.getSessionProc()
				let href = location.origin
				let coCode = "www"
				let routerWildcardRegex = /:(.*)[?]*/

				if (coInfoVO != null) {
					coCode = coInfoVO.coCode == null ? "www" : coInfoVO.coCode
				}

				// IP 주소인지 확인
				const isIPAddress = location.hostname.match(/^\d+\.\d+\.\d+\.\d+$/) || location.hostname === 'localhost' || location.hostname === '127.0.0.1'

				// URL 구성 헬퍼 함수
				const buildUrl = (hostname, port, path = '') => {
					return location.protocol + "//" + hostname + (port ? ":" + port : "") + path;
				};
				
				// 도메인에서 서브도메인을 교체하는 함수
				const replaceSubdomain = (origin, oldSubdomain, newSubdomain) => {
					if (isIPAddress || oldSubdomain === newSubdomain) {
						return origin; // IP 주소이거나 서브도메인이 같으면 변경 불필요
					}
					
					const hostname = location.hostname;
					const parts = hostname.split('.');
					
					// ssflex.co.kr 같은 메인 도메인인 경우 (3개 파트)
					if (parts.length === 3) {
						// www를 추가: www.ssflex.co.kr
						if (newSubdomain === "www") {
							return location.protocol + "//" + newSubdomain + "." + hostname + (location.port ? ":" + location.port : "");
						} else {
							return location.protocol + "//" + newSubdomain + "." + hostname + (location.port ? ":" + location.port : "");
						}
					}
					
					// www.ssflex.co.kr 같은 서브도메인이 있는 경우 (4개 이상 파트)
					if (parts.length >= 4) {
						parts[0] = newSubdomain;
						const newHostname = parts.join('.');
						return location.protocol + "//" + newHostname + (location.port ? ":" + location.port : "");
					}
					
					return origin;
				};

				if (_this instanceof Vue) {
					let referrer = _this.$route.query.referrer

					if (referrer) {
						href = href + referrer
					}

					if (referrer) {
						if (this.$router.options.routes.concat(
							this.$router.options.routes.map(
								e1 => {
									let e = e1.children ? e1.children : []
									e.forEach(e2 => {
										e2.path = e1.path + '/' + e2.path
										e2.path = e2.path.replace('//', '/')
									})
									return e
								}
							)
								.flat()
						)
							.filter(e => {
								let path = e.path
								return path.replace(routerWildcardRegex, "*")
									.startsWith(
										referrer.split('/').map((e, i) => {
											if (routerWildcardRegex.test(path.split('/')[i])) {
												return "*"
											} else {
												return e
											}
										}).join('/')
									)
							}).length > 0
						) {
							// IP 주소일 때는 hostname을 직접 구성
							if (isIPAddress) {
								href = buildUrl(location.hostname, location.port, referrer)
							} else {
								const newOrigin = replaceSubdomain(location.origin, subDomain, coCode);
								href = newOrigin + referrer;
							}
						} else {
							// IP 주소일 때는 hostname을 직접 구성
							if (isIPAddress) {
								href = buildUrl(location.hostname, location.port)
							} else {
								href = replaceSubdomain(location.origin, subDomain, coCode);
							}
						}
					} else {
						// IP 주소일 때는 hostname을 직접 구성
						if (isIPAddress) {
							href = buildUrl(location.hostname, location.port)
						} else {
							href = replaceSubdomain(location.origin, subDomain, coCode);
						}
					}
				} else {
					href = location.origin
				}

				if (subDomain !== coCode) {
					this.$session.destroy()

					// const stoh = (s) => {
					// 	let i;
					// 	let r = "";
					// 	for (i = 0; i < s.length; i++) { r += ("000" + s.charCodeAt(i).toString(16)).slice(-4) }
					// 	return r
					// }
					//
					// let u = new URL(href)
					// u.hash = btoa(stoh(encodeURI(JSON.stringify(coInfoVO))))
					// location.href = u

					let iframeId = "ifr"
					let iframeElement = document.createElement("iframe")
					let self = this

					iframeElement.id = iframeId
					iframeElement.src = href
					iframeElement.style.display = 'none'

					document.querySelector('body').appendChild(iframeElement)
					let appendedIframeElement = document.getElementById(iframeId)

					$('#' + iframeId).on('load', () => {
						setTimeout(() => {
							appendedIframeElement.contentWindow.postMessage(coInfoVO, (new URL(href)).origin)
							self.$nextTick(() => {
								_callback instanceof Function ? _callback(href) : (() => { location.href = href })()
							})
						})
					})
				} else {
					_callback instanceof Function ? _callback(href) : (() => { location.href = href })()
					if (!_callback) {
						location.href = href
					}
				}
			} catch (e) {
				this.$session.destroy()
			}

		},


		doLogout() {

			this.$eventBus.$emit("startProgress", 2)
			this.$nextTick(() => {
				this.$session.destroy()
				this.$eventBus.$emit("doneProgress", 2)

				location.reload()
			})

		},


		/**
		 * 마지막 데이터 통신 기록시간 저장
		 */
		doSyncdate() {
			const currDate = new Date().getTime()
			this.$session.set(SESSION_DATE, currDate)
			console.log(moment(this.getLastTimes()).format("YYYY-MM-DD HH:mm:ss"))
		},


		getLastTimes() {
			return new Date(this.$session.get(SESSION_DATE));
		},


		isTimeout() {

			// 로그인 유지 옵션 확인
			if (!this.getSessionProc().isKeepSession) {
				if (this.isLogin() && (new Date()).getTime() - this.getLastTimes().getTime() > TIMEOUT) {
					console.log("SESSION TIME OUT!!!")
					this.swalUtils.gritter("로그아웃 됩니다.", "로그인 유지 시간이 초과되어 로그아웃 됩니다.", "info")
					this.doLogout();
					return false;
				}
			}

		},

		getCookie(name) {    //쿠키 존재 확인 (없으면 null 반환)
			var dc,
				prefix,
				begin,
				end;

			dc = document.cookie;
			prefix = name + "=";
			begin = dc.indexOf("; " + prefix);
			end = dc.length;

			if (begin !== -1) {

				begin += 2;
			} else {

				begin = dc.indexOf(prefix);

				if (begin === -1 || begin !== 0) return null;
			}

			if (dc.indexOf(";", begin) !== -1) {
				end = dc.indexOf(";", begin);
			}

			return decodeURI(dc.substring(begin + prefix.length, end)).replace(/"/g, '');
		},


	},
	filters: {

		getLoginSession() {
			if (this.$session.get(SESSION_KEY) === undefined) {
				return null;
			}
			return this.$session.get(SESSION_KEY);
		},

	},

}
